import Realtime from "@assets/fonts/Realtime/Realtime-Rounded.otf";
import RealtimeSemiBold from "@assets/fonts/Realtime/Realtime-Rounded-Semibold.otf";

interface Font {
  url: typeof Realtime;
  weight: string;
  local: string;
}

const fonts: Font[] = [
  { url: Realtime, weight: "400 500", local: "Realtime-Rounded" },
  { url: RealtimeSemiBold, weight: "600", local: "Realtime-Rounded-Semibold" },
];

const getFontFace = (font: Font) => `
@font-face {
  font-family: 'Realtime';
  font-style: normal;
  font-display: swap;
  font-weight: ${font.weight};
  src: local('Realtime'), local('${font.local}'), url(${font.url}) format('opentype');
}
`;

const getFontFaces = () => fonts.map((font) => getFontFace(font)).join("\n");

export default getFontFaces();
